import axios from "axios"
import { useQuery } from "@tanstack/vue-query"

const path = "/partner/subordinates"

const useHierarchy = (enabled = true) => {
  const { isFetching, data: subordinates } = useQuery({
    queryKey: ["fetchPartnerSubordinates"],
    enabled,
    async queryFn() {
      const { data } = await axios.get(path)
      return data
    },
    placeholderData: () => ([]),
  })

  return {
    isFetching,
    subordinates,
  }
}

export {
  useHierarchy,
}
